import React from 'react';
import { motion } from 'framer-motion';

const STEPS = [
  { num: '01', icon: '📋', title: 'Scope & Requirement Review',      desc: 'Confirm statutory rules (Sec 28/29/31/41), asset count, and target dates.' },
  { num: '02', icon: '🔬', title: 'Onsite Physical Verification',    desc: 'Deploy certified technical inspectors for load testing, UT thickness, and audits.' },
  { num: '03', icon: '📄', title: 'Traceable Certification & Report', desc: 'Deliver Form 8/9/10/11 certificates and actionable compliance recommendations.' },
];

export default function HowWeWork() {
  return (
    <section id="how-we-work" className="section-pad bg-white relative overflow-hidden">
      <div className="container-xl relative z-10">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="section-label"
        >
          <span className="w-8 h-px bg-brand-orange" /> Our Methodology
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="font-heading font-black text-4xl sm:text-5xl text-brand-heading mb-14 leading-tight"
        >
          HOW WE <span className="text-gradient">DELIVER ASSURANCE</span>
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-6 relative">
          <div className="hidden md:block absolute top-10 left-[calc(16.67%+24px)] right-[calc(16.67%+24px)] h-px bg-gradient-to-r from-brand-orange/30 via-brand-orange/15 to-brand-orange/30" />

          {STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              whileHover={{ y: -5, transition: { duration: 0.25 } }}
              className="card card-hover rounded-2xl p-7 relative group"
            >
              <div className="w-12 h-12 rounded-xl bg-brand-orange flex items-center justify-center font-heading font-black text-white text-sm mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300">
                {step.num}
              </div>
              <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center text-xl mb-4">
                {step.icon}
              </div>
              <h3 className="font-heading font-bold text-brand-heading text-lg mb-3 group-hover:text-brand-orange transition-colors duration-300">{step.title}</h3>
              <p className="text-brand-subtle text-sm leading-relaxed">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
